import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Marquee } from "@/components/site/Marquee";
import { SplitCTA } from "@/components/site/SplitCTA";
import { SeasonalPromos } from "@/components/site/SeasonalPromos";
import { WhyUs } from "@/components/site/WhyUs";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { StickyCTA } from "@/components/site/StickyCTA";
import { SubscribePopup } from "@/components/site/SubscribePopup";

export default function Home() {
  return (
    <div data-testid="home-page" className="pb-20 md:pb-0">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Marquee />
        <SplitCTA />
        <SeasonalPromos />
        <WhyUs />
        <QuoteForm />
      </main>
      <Footer />
      <StickyCTA />
      <SubscribePopup />
    </div>
  );
}
